var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./ChangeMobileVersion.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-24c9d2fc!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChangeMobileVersion.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MobileVersion/ChangeMobileVersion.vue
// module id = 404
// module chunks = 1